var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 159.19 56.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".badgecls1,.badgecls2,.badgecls9{fill:#fff;}.badgecls2{stroke:#fff;stroke-miterlimit:10;stroke-width:0.22px;}.badgecls3{fill:url(#linear-gradient);}.badgecls4{fill:url(#linear-gradient-2);}.badgecls5{fill:url(#linear-gradient-3);}.badgecls6{fill:url(#linear-gradient-4);}.badgecls7,.badgecls8{fill:#282827;}.badgecls7,.badgecls8,.badgecls9{isolation:isolate;}.badgecls7{opacity:0.2;}.badgecls8{opacity:0.12;}.badgecls9{opacity:0.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30.57,
    y1: -2635.6,
    x2: 12.32,
    y2: -2653.85,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -2621.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4896d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4998d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#41b8ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#3fc6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#55c8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ac8e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 43.66,
    y1: -2647.88,
    x2: 17.34,
    y2: -2647.88,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -2621.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fddf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fdbc11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9a31a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89b1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 33.86,
    y1: -2650.37,
    x2: 9.11,
    y2: -2675.13,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -2621.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee3f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c11e63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 14.8,
    y1: -2626.31,
    x2: 25.85,
    y2: -2637.37,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -2621.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#319f71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2ba670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4ab870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5dbc6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66bd68"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.26,
    y: 5.22,
    width: 146.01,
    height: 42.68,
    rx: 5.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "badgecls1",
    d: "M147.24,5.63a4.62,4.62,0,0,1,4.62,4.61V42.87a4.62,4.62,0,0,1-4.62,4.61h-136a4.61,4.61,0,0,1-4.61-4.61V10.24a4.61,4.61,0,0,1,4.61-4.61h136m0-.83h-136a5.46,5.46,0,0,0-5.44,5.44V42.87a5.46,5.46,0,0,0,5.44,5.44h136a5.45,5.45,0,0,0,5.44-5.44V10.24a5.45,5.45,0,0,0-5.44-5.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls2",
    d: "M58.44,15.94a2.94,2.94,0,0,1-.81,2.18,3.16,3.16,0,0,1-2.4,1,3.36,3.36,0,0,1-3.39-3.41,3.36,3.36,0,0,1,3.39-3.41,3.41,3.41,0,0,1,1.34.27,2.9,2.9,0,0,1,1,.73l-.58.58a2.18,2.18,0,0,0-1.78-.78,2.54,2.54,0,0,0-2.54,2.61,2.54,2.54,0,0,0,2.54,2.61,2.5,2.5,0,0,0,1.82-.73,2.05,2.05,0,0,0,.55-1.32H55.23v-.79h3.16A2.91,2.91,0,0,1,58.44,15.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls2",
    d: "M63.45,13.22h-3v2.07h2.68v.78H60.48v2.07h3v.8H59.64V12.42h3.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls2",
    d: "M67,18.94h-.84V13.22H64.32v-.8h4.49v.8H67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls2",
    d: "M72.05,18.94V12.42h.84v6.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls2",
    d: "M76.61,18.94h-.84V13.22H74v-.8h4.48v.8H76.61Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls2",
    d: "M86.92,18.1a3.38,3.38,0,0,1-4.78,0,3.53,3.53,0,0,1,0-4.84,3.38,3.38,0,0,1,4.78,0,3.53,3.53,0,0,1,0,4.84Zm-4.16-.55a2.49,2.49,0,0,0,3.54,0A2.52,2.52,0,0,0,87,15.68a2.52,2.52,0,0,0-.73-1.87,2.49,2.49,0,0,0-3.54,0A2.52,2.52,0,0,0,82,15.68,2.52,2.52,0,0,0,82.76,17.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls2",
    d: "M89.06,18.94V12.42h1l3.17,5.07h0l0-1.25V12.42h.84v6.52h-.87L89.9,13.62h0l0,1.26v4.06Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls1",
    d: "M81,28.46a4.63,4.63,0,1,0,4.64,4.63A4.56,4.56,0,0,0,81,28.46Zm0,7.43a2.81,2.81,0,1,1,2.61-2.8A2.68,2.68,0,0,1,81,35.89ZM70.84,28.46a4.63,4.63,0,1,0,4.64,4.63A4.56,4.56,0,0,0,70.84,28.46Zm0,7.43a2.81,2.81,0,1,1,2.61-2.8A2.68,2.68,0,0,1,70.84,35.89Zm-12.05-6v2h4.7a4.08,4.08,0,0,1-1.07,2.47,4.81,4.81,0,0,1-3.63,1.44,5.22,5.22,0,0,1,0-10.44,5,5,0,0,1,3.54,1.4l1.38-1.38a6.8,6.8,0,0,0-4.92-2,7.19,7.19,0,1,0,0,14.37,6.57,6.57,0,0,0,5-2,7.15,7.15,0,0,0,1.6-5.82Zm49.28,1.53a4.3,4.3,0,0,0-4-2.95,4.4,4.4,0,0,0-4.36,4.63,4.52,4.52,0,0,0,4.59,4.62,4.58,4.58,0,0,0,3.85-2.05l-1.58-1a2.63,2.63,0,0,1-2.27,1.28,2.36,2.36,0,0,1-2.25-1.4l6.19-2.56ZM101.76,33a2.54,2.54,0,0,1,2.42-2.7,1.79,1.79,0,0,1,1.72,1Zm-5,4.48h2V23.84h-2ZM93.4,29.5h-.07a3.17,3.17,0,0,0-2.43-1,4.63,4.63,0,0,0,0,9.25,3.14,3.14,0,0,0,2.43-1.05h.07v.67c0,1.77-.94,2.71-2.47,2.71A2.57,2.57,0,0,1,88.6,38.4l-1.77.73a4.41,4.41,0,0,0,4.1,2.74c2.39,0,4.4-1.41,4.4-4.82V28.74H93.4Zm-2.33,6.39a2.65,2.65,0,0,1-2.57-2.78,2.68,2.68,0,0,1,2.57-2.83,2.61,2.61,0,0,1,2.47,2.83A2.58,2.58,0,0,1,91.07,35.89Zm26.52-12h-4.86V37.43h2V32.28h2.83a4.23,4.23,0,1,0,0-8.44Zm0,6.55h-2.88V25.73h2.88a2.33,2.33,0,1,1,0,4.66Zm12.55-1.95a3.81,3.81,0,0,0-3.63,2.08l1.81.75a1.92,1.92,0,0,1,1.85-1A2,2,0,0,1,132.35,32v.14a4.45,4.45,0,0,0-2.11-.52c-1.94,0-3.92,1.06-3.92,3.06a3.14,3.14,0,0,0,3.38,3,2.84,2.84,0,0,0,2.58-1.33h.07v1h2V32.2C134.31,29.78,132.51,28.44,130.19,28.44Zm-.25,7.45c-.66,0-1.59-.33-1.59-1.16,0-1,1.15-1.45,2.15-1.45a3.52,3.52,0,0,1,1.85.46A2.45,2.45,0,0,1,129.94,35.89Zm11.51-7.16-2.33,5.9h-.07l-2.41-5.9h-2.19L138.07,37,136,41.56h2.12l5.58-12.83Zm-18.28,8.7h2V23.84h-2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls3",
    d: "M18.21,13a2.18,2.18,0,0,0-.5,1.53v24a2.15,2.15,0,0,0,.5,1.53l.08.08L31.77,26.72V26.4L18.29,12.92Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls4",
    d: "M36.26,31.21l-4.49-4.49V26.4l4.49-4.49.1.05,5.32,3c1.52.86,1.52,2.27,0,3.14l-5.32,3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls5",
    d: "M36.36,31.15l-4.59-4.59L18.21,40.11a1.77,1.77,0,0,0,2.26.07l15.89-9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls6",
    d: "M36.36,22l-15.89-9a1.77,1.77,0,0,0-2.26.06L31.77,26.56Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls7",
    d: "M36.26,31.05,20.47,40a1.81,1.81,0,0,1-2.18,0h0l-.08.08h0l.08.08h0a1.81,1.81,0,0,0,2.18,0l15.89-9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls8",
    d: "M18.21,40a2.14,2.14,0,0,1-.5-1.52v.16a2.14,2.14,0,0,0,.5,1.52l.08-.08Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls8",
    d: "M41.68,28l-5.42,3.08.1.1,5.32-3a1.9,1.9,0,0,0,1.14-1.57h0A2,2,0,0,1,41.68,28Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "badgecls9",
    d: "M20.47,13.09,41.68,25.15a2,2,0,0,1,1.14,1.41h0A1.9,1.9,0,0,0,41.68,25l-21.21-12c-1.52-.87-2.76-.15-2.76,1.59v.16C17.71,13,19,12.23,20.47,13.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google_play_badge.8e09a6f49baad73a857f291ebfcf1600.svg";
export { ForwardRef as ReactComponent };